import { useMemo, useState } from "react";
import { useForms } from "../../hooks/useForms";
import panel from "./AddWorkflowPanel.module.css";

interface Props {
  portalId: string;
  onAdd: (formId: string) => void;
  placedFormIds: Set<string>;
  onClose: () => void;
}

export default function AddFormPanel({
  portalId,
  onAdd,
  placedFormIds,
  onClose,
}: Props) {
  const { items, loading, error } = useForms(portalId);
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter((f) => f.name.toLowerCase().includes(q));
  }, [items, query]);

  return (
    <div className={panel.panel}>
      <header className={panel.header}>
        <h2 className={panel.title}>Add form</h2>
        <button
          type="button"
          className={panel.close}
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
      </header>

      <input
        className={panel.search}
        placeholder="Search forms…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      {loading && <div className={panel.empty}>Loading…</div>}
      {error && <div className={panel.error}>{error}</div>}
      {!loading && !error && filtered.length === 0 && (
        <div className={panel.empty}>No forms match.</div>
      )}

      <ul className={panel.list}>
        {filtered.map((f) => {
          const placed = placedFormIds.has(f.id);
          return (
            <li key={f.id}>
              <button
                type="button"
                className={panel.row}
                disabled={placed}
                onClick={() => onAdd(f.id)}
              >
                <span className={panel.rowName}>{f.name}</span>
                <span className={panel.rowMeta}>
                  {f.formType ?? "form"}
                  {placed ? " · placed" : ""}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
